import CSDTable, {
  TableProps,
} from "@cloudscape-design/components-themed/table";
import { useGetAnnouncementsQuery } from "../../features/api";
import { useEffect, useState } from "react";
import { Announcement } from "../../features/api-interfaces";
import { isUndefined } from "lodash";
import { COMMON_LABELS } from "../default-constants";
import {
  Box,
  Button,
  CollectionPreferencesProps,
  Header,
  Link,
  Modal,
  SpaceBetween,
  TextContent,
} from "@cloudscape-design/components-themed";
import Pagination from "../UI/Pagination";
import { DEFAULT_PAGE_SIZE } from "../../configs/constants";
import { getHeaderCounterText, getPagedItems } from "../../utils/common";
import MultilineText from "../UI/MultilineText";
import Preference from "../UI/Preference";
import { CategoryBadge } from "./CategoryBadge";

/**
 * お知らせ一覧
 */
export const Main = () => {
  // テーブル定義
  const columnDefinitions: TableProps.ColumnDefinition<Announcement>[] = [
    {
      id: "announcement",
      header: "",
      cell: (item: Announcement) => (
        <SpaceBetween direction={"vertical"} size={"xxs"}>
          <Link onFollow={() => setAnnouncement(item)}>{item.title}</Link>
          <SpaceBetween direction={"horizontal"} size={"xxs"}>
            <TextContent>
              <p>{item.postDateTime}</p>
            </TextContent>
            <CategoryBadge categoryCode={item.category} />
          </SpaceBetween>
        </SpaceBetween>
      ),
    },
  ];
  const [allItems, setAllItems] = useState<Announcement[]>([]);
  const [pagedItems, setPagedItems] = useState<Announcement[]>([]);
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [preferences, setPreferences] = useState({
    pageSize: DEFAULT_PAGE_SIZE,
    visibleContent: columnDefinitions.map((column) => column.id!),
  });
  const [announcement, setAnnouncement] = useState<Announcement | undefined>(
    undefined
  );
  const { data: apiResponse, isFetching, refetch } = useGetAnnouncementsQuery();

  useEffect(() => {
    if (!isUndefined(apiResponse)) {
      setPagedItems(
        getPagedItems(apiResponse, 1, preferences.pageSize) as Announcement[]
      );
      setAllItems(apiResponse);
      setCurrentPageIndex(1);
    }
  }, [apiResponse, preferences.pageSize]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  /**
   * ページサイズを変更したときのハンドラ.
   * @param {CollectionPreferencesProps.Preferences} detail
   */
  const handleOnConfirm = (detail: CollectionPreferencesProps.Preferences) => {
    const newPageSize = detail.pageSize!;
    setPreferences({
      pageSize: newPageSize,
      visibleContent: detail.visibleContent! as string[],
    });
    if (!isUndefined(apiResponse)) {
      setPagedItems(apiResponse.slice(0, newPageSize));
      setCurrentPageIndex(1);
    }
  };

  /**
   * モーダルを閉じる処理.
   */
  const onClose = () => setAnnouncement(undefined);

  return (
    <>
      <CSDTable
        header={
          <Header>
            {"お知らせ一覧"}
            {getHeaderCounterText(allItems.length, pagedItems.length)}
          </Header>
        }
        columnDefinitions={columnDefinitions}
        loading={isFetching}
        loadingText={COMMON_LABELS.CSD.LOADING_TEXT}
        items={pagedItems}
        pagination={
          <Pagination
            currentPageIndex={currentPageIndex}
            filteredItems={allItems}
            setCurrentPageIndex={setCurrentPageIndex}
            pageSize={preferences.pageSize}
            setPagedItems={setPagedItems}
          />
        }
        preferences={
          <Preference
            preferences={preferences}
            handleOnConfirm={handleOnConfirm}
          />
        }
      />
      {!isUndefined(announcement) && (
        <Modal
          onDismiss={onClose}
          visible={!isUndefined(announcement)}
          size={"large"}
          header={announcement?.title}
          footer={
            <Box float={"left"}>
              <Button formAction={"none"} variant={"link"} onClick={onClose}>
                {COMMON_LABELS.BTNS.CLOSE}
              </Button>
            </Box>
          }
        >
          <SpaceBetween direction={"vertical"} size={"l"}>
            <SpaceBetween direction={"horizontal"} size={"xxs"}>
              {`投稿日時：${announcement?.postDateTime}`}
              <CategoryBadge categoryCode={announcement?.category ?? ""} />
            </SpaceBetween>
            <MultilineText content={announcement?.content ?? ""} />
          </SpaceBetween>
        </Modal>
      )}
    </>
  );
};
